import { Component, OnInit } from '@angular/core';
import { UserService, TranslationService, CongresosService } from '../../services/services.index';
import { Congreso } from '../../models/congreso.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-certificados-cursos',
  templateUrl: './certificados-cursos.component.html',
  styles: []
})
export class CertificadosCursosComponent implements OnInit {

  cursos: any = [];
  loading: boolean = true;

  congreso: Congreso;
  certificadosHabilitados: boolean = false;

  constructor(public _userService: UserService,
    public _translationService: TranslationService,
    public _congresosService: CongresosService,
              public router: Router) { }

  ngOnInit() {
    this.loading = true;
    this._userService.getCursosUsuario().subscribe((resp: any) => {
      this.cursos = resp.actividades;
      this.cargarCongreso();
    });
  }

  cargarCongreso() {
    this.loading = true;
    this._congresosService.getCongresoActivo().subscribe(resp => {
      if (resp.length === 1) {
        this.congreso = resp[0];
        let today: number = new Date().getTime();
        if (today > this.congreso.fechaFinCongreso) {
          this.certificadosHabilitados = true;
        } else {
          this.certificadosHabilitados = false;
          let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Certificados no habilitados';
            mensajeSwal = 'Los certificados seran habilitados una vez finalice el congreso.';
          } else {
            tituloSwal = 'Certificates not enabled';
            mensajeSwal = 'The certificates will be enabled once the congress ends.';
          }

          swal(tituloSwal, mensajeSwal, 'error');
          this.router.navigate(['/dashboard']);
        }
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados/certificados-cursos/certificados-cursos.component.ts